var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWheel = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9974 16.3346C15.2861 16.3346 16.3307 15.29 16.3307 14.0013C16.3307 12.7126 15.2861 11.668 13.9974 11.668C12.7087 11.668 11.6641 12.7126 11.6641 14.0013C11.6641 15.29 12.7087 16.3346 13.9974 16.3346Z",
    fill: "#20AA67",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0016 2.33398V7.00065M7.9349 17.5007L3.85156 19.834M24.1516 8.16732L20.0682 10.5007M7.9349 10.5007L3.85156 8.16732M24.1516 19.834L20.0682 17.5007M10.5016 25.6673L14.0016 16.334L17.5016 25.6673M9.3349 25.6673H18.6682",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21.8165C22.585 20.3988 23.7022 18.5333 24.2038 16.4668C24.7053 14.4002 24.5676 12.2301 23.8088 10.2436C23.05 8.25707 21.7059 6.54776 19.9544 5.34184C18.2029 4.13591 16.1265 3.49023 14 3.49023C11.8735 3.49023 9.7971 4.13591 8.04558 5.34184C6.29406 6.54776 4.94998 8.25707 4.19119 10.2436C3.43241 12.2301 3.29468 14.4002 3.79624 16.4668C4.29779 18.5333 5.41499 20.3988 7 21.8165",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWheel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wheel.d1018ce018393794d1569260cb9c285d.svg";